// Autogenerated from `packages/@members/copy/copy.generated/__copy__.ts.hbs`

import { toCopyComponent, toFormattedText } from '@peloton/copy';
import type { CopyHook } from '@peloton/copy-generic';
import type { CopyIDs } from '../CopyIDs';
import { useAllCopy } from '../CopyProvider/CopyProvider';
import type { AccountSetup } from '../models.generated';

export const useAccountSetup: CopyHook<CopyIDs<typeof AccountSetup>> = (id, values) => {
  const copy = useAllCopy();
  const value = copy?.accountSetupCollection?.[id];

  if (!value) {
    console.error(`No copy found for id ${id}`);
    return '';
  }

  return toFormattedText(value, values) as string;
};

export const AccountSetupCopy = toCopyComponent(useAccountSetup);
